import React from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import { QueryComponent } from '../../../../GraphQL';
import { getClassroomQuizExamPaperResultById } from '../../../../GraphQL/query/Classroom.query';
import { useQuizContext } from '../../../../Context/QuizContext';
import { EXAM_PAPER_ITEM_TYPE } from '../../constant';

import { RESULT_TYPE } from './constant';

const SolutionRoute = ({ match, location, children }) => {
  const [roundIndex, setRoundIndex] = React.useState(null);
  const { examSessionId } = match.params;
  const { variant } = useQuizContext();

  React.useEffect(() => {
    const { roundIndex } = qs.parse(location.search);
    setRoundIndex(roundIndex);
  }, []);

  return (
    <QueryComponent query={getClassroomQuizExamPaperResultById} variables={{ examSessionId }}>
      {(data) => {
        const { score, fullScore, examPaperItemViews } = data.classroomQuizExamPaper || {};
        const examPaperItemTypesToShowScore = [
          EXAM_PAPER_ITEM_TYPE.MULTIPLE_CHOICE_DIFFERENT_SCORE,
          EXAM_PAPER_ITEM_TYPE.MULTIPLE_SELECT_WITH_CORRECT_ANSWERS,
          EXAM_PAPER_ITEM_TYPE.CONNECTION,
        ];
        const isShowScore = examPaperItemViews.some((item) =>
          examPaperItemTypesToShowScore.includes(item.type)
        );

        const results = examPaperItemViews.map((item, index) => {
          const { isCorrect, id, scoreRatio, examScoreScale } = item;
          const result = isCorrect ? RESULT_TYPE.CORRECT : RESULT_TYPE.INCORRECT;
          const score = examScoreScale ? scoreRatio * examScoreScale : scoreRatio;
          return {
            index,
            id,
            result,
            score,
          };
        });

        return children({
          variant,
          solutionData: {
            score,
            fullScore,
            results,
            isShowScore,
            round: roundIndex,
          },
        });
      }}
    </QueryComponent>
  );
};

export default withRouter(SolutionRoute);
